import { Global } from "../Global";
import { Order, PdfContract, QuickContract } from "../models/OrderContract";
import { post } from "../utils/ApiUtil";

// 获取指定时间后更新的所有订单
const getOrdersAfterTime = async (afterTime: number): Promise<Order[]> => {
    if (Global.isMockMode()) {
       const mockData = Global.getMockData("getOrdersAfterTime");
       console.log("mockData:", mockData);
       if(mockData && Array.isArray(mockData)){
        return mockData;
       }
       // 如果 mock 数据不存在或不是数组，返回空数组
       console.warn("Mock 数据不存在或格式错误，返回空数组");
       return [];
    }
    const resultOrErrorCode = await post<{ afterTime: number }, Order[]>("/order/getOrdersAfterTime", { afterTime });
    if(typeof resultOrErrorCode === 'string'){
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};
  
  // 获取指定orderId的订单详情
const getOrderDetail = async (orderId: string): Promise<Order | null> => { 
    if (Global.isMockMode()) {
    // 增加假的等待时间，模拟网络请求延迟
    await new Promise(resolve => setTimeout(resolve, 1000));
    return Global.getMockData("getOrderDetail_"+orderId);
    }
    const resultOrErrorCode = await post<{ orderId: string }, Order>("/order/getOrderDetail", { orderId });
    if(typeof resultOrErrorCode === 'string'){
    // 错误码处理
    return null;
    }
    return resultOrErrorCode;
};

// 查询PDF合约信息
const queryPdfContractById = async (contractId: string): Promise<PdfContract | null> => {
    if(Global.isMockMode()){
        // 添加人为延迟
        await new Promise(resolve => setTimeout(resolve, 800));
        const mockData = Global.getMockData("queryPdfContractById_"+contractId);
        if(mockData){
            mockData.pdfUrl = mockData.pdfUrl;
            if(!mockData.signTime){
                mockData.signTime = new Date().toISOString();
            }
            if(!mockData.posterSignTime){
                mockData.posterSignTime = new Date().toISOString();
            }
        }
        //console.log("mockData:", mockData);
        return mockData;
    }
    const resultOrErrorCode = await post<string, PdfContract>(
        "/contract/queryPdfContractById",
        contractId,
    );
    if(typeof resultOrErrorCode === 'string'){
        // 错误码处理
        return null;
    }
    return resultOrErrorCode;
};

const queryQuickContractById = async (contractId: string): Promise<QuickContract | null> => {
    if (Global.isMockMode()) {
        await new Promise(resolve => setTimeout(resolve, 800));
        return Global.getMockData("queryQuickContractById_" + contractId);
    }
    const resultOrErrorCode = await post<string, QuickContract>(
        "/contract/queryQuickContractById",
        contractId,
        { quiet: true, logTag: 'orderContract:queryQuickContractById' },
    );
    if (typeof resultOrErrorCode === 'string') {
        return null;
    }
    return resultOrErrorCode;
};

const queryQuickContractsByIds = async (
    contractIds: string[],
): Promise<QuickContract[]> => {
    if (!contractIds.length) return [];
    if (Global.isMockMode()) {
        const contracts: QuickContract[] = [];
        for (const contractId of contractIds) {
            const contract = Global.getMockData("queryQuickContractById_" + contractId);
            if (contract) contracts.push(contract);
        }
        return contracts;
    }
    const resultOrErrorCode = await post<string[], QuickContract[]>(
        "/contract/queryQuickContractsByIds",
        contractIds,
    );
    if (typeof resultOrErrorCode === 'string' || !Array.isArray(resultOrErrorCode)) {
        return [];
    }
    return resultOrErrorCode;
};

const queryPdfContractsByIds = async (
    contractIds: string[],
): Promise<PdfContract[]> => {
    if (!contractIds.length) return [];
    if (Global.isMockMode()) {
        const contracts: PdfContract[] = [];
        for (const contractId of contractIds) {
            const contract = Global.getMockData("queryPdfContractById_" + contractId);
            if (contract) contracts.push(contract);
        }
        return contracts;
    }
    const resultOrErrorCode = await post<string[], PdfContract[]>(
        "/contract/queryPdfContractsByIds",
        contractIds,
    );
    if (typeof resultOrErrorCode === 'string' || !Array.isArray(resultOrErrorCode)) {
        return [];
    }
    return resultOrErrorCode;
};

const addPdfContract = async (pdfContract: {
    contractName:string,
    pdfUrl:string,
    orderId:string,
    posterType?: number,
    pdfSignMode?: number,
}): Promise<PdfContract | null> => {
    if(Global.isMockMode()){
        return null;
    }
    const resultOrErrorCode = await post<typeof pdfContract, PdfContract>("/contract/addPdfContract", pdfContract);
    if(typeof resultOrErrorCode === 'string'){
        // 错误码处理
        return null;
    }
    return resultOrErrorCode;
};


export const OrderContractApi = {
    getOrdersAfterTime,
    getOrderDetail,
    queryPdfContractById,
    queryQuickContractById,
    queryPdfContractsByIds,
    queryQuickContractsByIds,
    addPdfContract
};